"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAwaitableEventEmitter = createAwaitableEventEmitter;
var Deferred_1 = require("./Deferred");
var tsafe_1 = require("../vendor/frontend/tsafe");
function createAwaitableEventEmitter() {
    var eventTarget = new EventTarget();
    var KEY = "event";
    return {
        waitFor: function () {
            var d = new Deferred_1.Deferred();
            var listener = function (e) {
                (0, tsafe_1.assert)((0, tsafe_1.is)(e));
                eventTarget.removeEventListener(KEY, listener);
                d.resolve(e.detail);
            };
            eventTarget.addEventListener(KEY, listener);
            return d.pr;
        },
        post: function (data) {
            eventTarget.dispatchEvent(new CustomEvent(KEY, { detail: data }));
        }
    };
}
//# sourceMappingURL=AwaitableEventEmitter.js.map